module.exports = __webpack_public_path__ + "c3db495727f8bf5579a992314c43cedf.svg";